export const GET_FLOOR_PLAN = 'GET_FLOOR_PLAN';
export const SHOW_LOADING = 'SHOW_LOADING';